module.exports = "/static/assets/223e926c7036a87ef1b5f5d6e07ac7eb.jpg";